module.exports = __webpack_public_path__ + "img/logo.8506d213.svg";